import { render } from "./ColorpaletteComponent.vue?vue&type=template&id=402c71d0"
import script from "./ColorpaletteComponent.vue?vue&type=script&lang=js"
export * from "./ColorpaletteComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__